<template>
  <COverflowWrapper :max-height="480">
    <CTypographyConfigurator
      class="w-full"
      :configuration="modelValue"
      :font-options="fontOptions"
      :palette="palette"
      @update:configuration="(newConfig) => emit('update:modelValue', newConfig)"
    />
  </COverflowWrapper>
</template>

<script setup lang="ts">
import type { SelectOption } from 'naive-ui'

import CTypographyConfigurator from '@lib/components/CTypographyConfigurator/CTypographyConfigurator.vue'
import COverflowWrapper from '@lib/components/COverflowWrapper/COverflowWrapper.vue'
import type { CanvasTypographyPreset } from '@lib/types/canvasTheme'

defineProps<{
  modelValue: Record<string, CanvasTypographyPreset>
  fontOptions: SelectOption[]
  palette?: string[]
}>()

const emit = defineEmits<{
  'update:modelValue': [value: Record<string, CanvasTypographyPreset>]
}>()
</script>
<style scoped>
:deep(.n-collapse-item__header-main) {
  padding: 0 !important;
}
</style>
